module.exports = __webpack_public_path__ + "static/assets/0f0b7f392ad073584a28c2feb1702045.png";